import useReveal from "@/hooks/useReveal";
import DestinationCard from "@/components/home/DestinationCard";

const LAYOUTS = [
  "col-span-12 md:col-span-7 row-span-2",
  "col-span-12 md:col-span-5 row-span-2",
  "col-span-12 md:col-span-5 row-span-2",
  "col-span-12 md:col-span-7 row-span-2",
];

export default function DestinationsSection({ destinations }) {
  const r = useReveal();
  return (
    <section ref={r} className="relative bg-ivory-alt py-32 md:py-40">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-20 gap-6">
          <div>
            <div className="eyebrow mb-6">The Compass</div>
            <h2 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight font-light">
              Four lands, <br />
              <span className="italic text-indigo_deep">one quiet horizon.</span>
            </h2>
          </div>
          <p className="max-w-sm text-ink/65 leading-relaxed font-light">
            Each destination is a chapter — read alone, or composed into a
            longer manuscript of travel.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6 auto-rows-[180px] md:auto-rows-[230px]">
          {destinations.map((d, idx) => (
            <DestinationCard
              key={d.slug}
              d={d}
              idx={idx}
              className={LAYOUTS[idx]}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
